import { render, staticRenderFns } from "./SuccessPopUp.vue?vue&type=template&id=72c8e0a2&scoped=true&"
var script = {}
import style0 from "./SuccessPopUp.vue?vue&type=style&index=0&id=72c8e0a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8e0a2",
  null
  
)

export default component.exports